module.exports = __webpack_public_path__ + "static/media/17.2404a3de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/17.jpg
// module id = 386
// module chunks = 0